import { useTranslation } from 'react-i18next';

import { InterventionStatus } from '../../business/interventionButtonMenu.const';
import { useSelectIsStore } from '../../apis/startup/startup.selectors';

const buildFilter = (id: InterventionStatus, label: string) => {
  return {
    id,
    label,
    selected: true,
  };
};

export const usePlanningStateFilter = () => {
  const { t } = useTranslation();
  const isRW = !useSelectIsStore();

  const statesLabels = isRW
    ? [
        [InterventionStatus.toProcess, InterventionStatus.receivedForProcessingInRW],
        [InterventionStatus.storeShortage, InterventionStatus.RWShortage],
        [InterventionStatus.forReceptionInRW],
        [InterventionStatus.deliveredToPartnerFromStore, InterventionStatus.deliveredToPartnerFromRw],
      ]
    : ([[InterventionStatus.toProcess], [InterventionStatus.storeShortage], [InterventionStatus.deliveredToPartnerFromStore]] as const);

  return statesLabels.map(id => ({
    ...buildFilter(id[0], t(`intervention.state.label.${id[0]}`)),
    subFilters: id.map(newId => ({
      ...buildFilter(newId, t(`intervention.state.label.${newId}`)),
    })),
  }));
};
